import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  linkedSignal,
  output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OdlInputEvent } from '@odilo/ui-components';
import { EllipsisDirective } from '../../../directives/ellipsis/ellipsis';
import { HighlightsService } from '../../../services/selections/highlights';
import { SelectionsService } from '../../../services/selections/selections';

@Component({
  selector: 'nr-note-share-dialog',
  imports: [TranslatePipe, EllipsisDirective],
  templateUrl: './note-share-dialog.html',
  styleUrl: '../notes.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NoteShareDialogComponent {
  private readonly highlightsService = inject(HighlightsService);
  private readonly selectionsService = inject(SelectionsService);

  readonly note = this.highlightsService.noteToEdit;
  readonly shareNote = this.highlightsService.shareNote;
  /** Whether the note text is shared along with the highlight (persisted as `publicNotes`). */
  readonly includeNote = linkedSignal(() => Boolean(this.note()?.publicNotes));

  readonly colorMap = this.highlightsService.colorMap;

  readonly dialogClosed = output();

  toggleIncludeNote(event: OdlInputEvent<boolean>): void {
    this.includeNote.set(event.detail.value);
  }

  async shareNoteLink(): Promise<void> {
    const note = this.note();
    if (!note) return;
    const publicNotes = this.includeNote();
    this.shareNote.set(false);
    this.highlightsService.noteToEdit.set(undefined);
    await this.selectionsService.shareSelectionLink(note, { publicNotes });
  }
}
